<script setup lang="ts">
import { t } from '@/i18n';
import { computed } from 'vue';
import { Sun, Moon } from '@lucide/vue';
import { useTheme } from '@/lib/theme';
defineProps<{ onBrand?: boolean }>();
const { resolved, setPreference } = useTheme();
const icon = computed(() => resolved.value === 'dark' ? Sun : Moon);
const label = computed(() => resolved.value === 'dark' ? t('common.lightMode') : t('common.darkMode'));
function toggle() { setPreference(resolved.value === 'dark' ? 'light' : 'dark'); }
</script>
<template>
  <button type="button" class="theme-selector" :class="{ 'on-brand': onBrand }" :title="label" :aria-label="label" @click="toggle">
    <Transition name="theme-symbol" mode="out-in"><component :is="icon" :key="resolved" class="theme-icon" aria-hidden="true"/></Transition>
  </button>
</template>
<style scoped>
.theme-selector{display:grid;place-items:center;flex:none;width:44px;height:44px;min-width:44px;min-height:44px;padding:0;border:1px solid var(--input-border);border-radius:9px;background:var(--surface);color:var(--ink);margin-left:auto;transition:background-color 140ms,border-color 140ms,transform 140ms}
.theme-selector:hover{background:var(--surface-hover);border-color:var(--primary);color:var(--primary)}
.theme-selector:focus-visible{outline:2px solid var(--focus);outline-offset:3px}
.theme-selector:active{transform:scale(.96)}
.theme-icon{width:19px;height:19px;stroke-width:1.8;pointer-events:none}
.theme-selector.on-brand{background:transparent;color:var(--header-text);border-color:color-mix(in srgb,var(--header-text) 32%,transparent)}
.theme-selector.on-brand:hover{background:color-mix(in srgb,var(--header-text) 12%,transparent);border-color:color-mix(in srgb,var(--header-text) 60%,transparent)}
.theme-selector.on-brand:focus-visible{outline-color:var(--header-text)}
.theme-symbol-enter-active,.theme-symbol-leave-active{transition:opacity 100ms,transform 100ms}
.theme-symbol-enter-from{opacity:0;transform:rotate(-25deg) scale(.8)}
.theme-symbol-leave-to{opacity:0;transform:rotate(25deg) scale(.8)}
@media(prefers-reduced-motion:reduce){.theme-selector,.theme-symbol-enter-active,.theme-symbol-leave-active{transition:none}.theme-selector:active,.theme-symbol-enter-from,.theme-symbol-leave-to{transform:none}}
@media(forced-colors:active){.theme-selector,.theme-selector.on-brand{color:ButtonText;border-color:ButtonText}}
</style>
